import { createSelector } from "reselect";
import User from "../../models/User";
import Organisation from "../../models/Organisation";
import Contribution from "../../models/Contribution";

const getStateSelector = (state) => state;
const getSchemaSelector = createSelector(
  getStateSelector,
  (state) => state.schema
);
const getUserFlagSelector = createSelector(
  getStateSelector,
  (state) => state.userFlag
);
const getCommentsSelector = createSelector(
  getStateSelector,
  (state) => state.comments
);

const getVariantFlags = createSelector(
  getStateSelector,
  (state) => state.variantFlags || []
);

const getVariantFlagContributions = createSelector(getVariantFlags, (flags) =>
  flags
    .map((x) => {
      const data = x.json_data || {};
      const { diseases, phenotypes, additional_info: additionalInfo } = data;
      const pathogenicity = x.flag;

      const c = new Contribution({
        ...x,
        ...data,
        canEdit: x.can_edit,
        diseases,
        phenotypes,
        additionalInfo,
        pathogenicity,
        date_created: x.flagged_at,
      });
      const org = new Organisation({ name: x.userOrganisation });
      const fullName = x.user__full_name || x.user__screen_name;
      const screenName = x.user__screen_name;
      const userSsoIdHashed = x.user__open_id_identifier_hashed;
      return c.setUser(
        new User({ fullName, screenName, userSsoIdHashed }, org)
      );
    })
    .sort((a, b) => b.createdAt - a.createdAt)
);

const getVariantResult = createSelector(
  getStateSelector,
  (state) => state.variantResult
);

const getQueryType = createSelector(getStateSelector, (state) =>
  state.queryType === "gene" ? "gene" : "variant"
);

export {
  getSchemaSelector,
  getUserFlagSelector,
  getCommentsSelector,
  getVariantFlags,
  getVariantResult,
  getQueryType,
  getVariantFlagContributions,
};
